import { errorCodes } from '@/services/api/errorCodes';
import { checkPassword, fetchAdminWalletBalance, setPassword, setPin, withdraw } from '@/services/api/SettingApi';
import { tryLogout } from './LoginController';
import { getStores } from '@/stores';

/**
 * 비밀번호 체크
 * @param {string} userId
 * @param {string} password
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function tryCheckPassword(
  userId: string,
  password: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const res = await checkPassword({ id: userId, password });

    console.log('res', res);
    // res가 문자열인 경우 (에러 코드)
    if (typeof res === 'string') {
      const errorInfo = errorCodes.find((error) => error.code === res);

      console.log('errorInfo', errorInfo);
      if (errorInfo) {
        return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
      }
      return { succed: false }; // 에러 코드를 찾지 못한 경우
    }

    // res가 문자열이 아닌 경우 (성공)
    return { succed: res === true }; // res 값에 따라 성공 여부 반환
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

/**
 * 비밀번호 변경
 * @param {string} userId
 * @param {string} prePassword
 * @param {string} newPassword
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function tryChangePassword(
  userId: string,
  prePassword: string,
  newPassword: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const res = await setPassword({ id: userId, prevPassword: prePassword, password: newPassword });

    // res가 문자열인 경우 (에러 코드)
    if (typeof res === 'string') {
      const errorInfo = errorCodes.find((error) => error.code === res);
      if (errorInfo) {
        return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
      }
      return { succed: false }; // 에러 코드를 찾지 못한 경우
    }

    // res가 문자열이 아닌 경우 (성공)
    return { succed: res === true }; // res 값에 따라 성공 여부 반환
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

/**
 * 회원 탈퇴
 * @param {string} id
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function tryWithdraw(
  id: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const res = await withdraw(id);
    console.log('res', res);

    if (typeof res === 'string') {
      const errorInfo = errorCodes.find((error) => error.code === res);
      if (errorInfo) {
        return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
      }
      return { succed: false };
    }

    if (res === true) {
      // 회원 탈퇴 성공 시 세션 제거 (로그아웃)
      await tryLogout();
    }

    return { succed: res === true };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

/**
 * PIN 변경
 * @param {string} id
 * @param {string} phone
 * @param {string} prevPin
 * @param {string} pin
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function trySetPin(
  id: string,
  phone: string,
  prevPin: string,
  pin: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const res = await setPin({ id, phone, prevPin, pin });

    // res가 문자열인 경우 (에러 코드)
    if (typeof res === 'string') {
      const errorInfo = errorCodes.find((error) => error.code === res);
      if (errorInfo) {
        return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
      }
      return { succed: false }; // 에러 코드를 찾지 못한 경우
    }

    // res가 문자열이 아닌 경우 (성공)
    return { succed: res === true }; // res 값에 따라 성공 여부 반환
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

/**
 *
 *
 * @export
 * @param {string} address
 * @return {*}  {Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }>}
 */
export async function tryFetchAdminWalletBalance(
  address: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> {
  try {
    const { presentationStore } = getStores();
    const res = await fetchAdminWalletBalance(address);

    if (res.status === 'error') {
      // showAlertPopup(replaceNewLineToTag(res.message), true, false, res.message);
      return { succed: false, errorMessage: res.message };
    } else {
      presentationStore.setAdminWalletBalance(res.response);

      return { succed: true };
    }
  } catch (error) {
    console.error(error);
    return { succed: false, errorMessage: 'Internal Server Error' };
  }
}
